// extracted by mini-css-extract-plugin
export default {"leftIconOuterContainer":"_8vj0vLFcoHgUMs7U1XvvYQ==","leftIconInnerContainer":"EzsYBybhZDXyv63dbuP0nQ==","learnModeIconContainer":"FkcRbHv7PFB7Zq66wBGw+w=="};